import { render, staticRenderFns } from "./handleFiles.vue?vue&type=template&id=7f97334f&scoped=true&"
import script from "./handleFiles.vue?vue&type=script&lang=js&"
export * from "./handleFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f97334f",
  null
  
)

export default component.exports